import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import * as Promise from 'bluebird';
import { Component } from 'react';
import {
  ColumnDefinition,
  getFilters,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from 'Src/helpers/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { Loader } from 'Src/components/Loader/Loader';
import { Grid } from 'Src/components/Grid/Grid';
import { SimpleModal } from '../../../../../../components/SimpleModal/SimpleModal';
import { PreRegistrationsUser } from '../../../../../../models/preRegistrationsUser';
import {
  deletePreRegistrationsUser,
  getAllPreRegistrationsUsers,
  getPreRegistrationsUsers,
  getPreRegistrationsUsersCount,
  resetLoginCountPreRegistrationsUser,
} from '../../../../../../services/superadmin/preRegistrationsUsers';
import { PreRegistrationsUsersLogsForm } from './PreRegistrationsUsersLogsForm/PreRegistrationsUsersLogsForm';
import { getCreatedAtWithTime, getSharedIsPreRegistrationsUser } from '../../../../../../helpers/accessor';
import { getSelectOptionForYesOrNo } from '../../../../../../helpers/select';
import { convertToFilterWithPlus } from '../../../../../../helpers/table';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'School',
    field: 'nameOfSchool',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['school', 'name'],
  },
  {
    text: 'School Reference',
    field: 'schoolCode',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['school', 'code'],
  },
  {
    text: 'Job Reference',
    field: 'jobReference',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['jobReference'],
  },
  {
    text: 'User name',
    field: 'username',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['username'],
  },
  {
    text: 'Password',
    field: 'password',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['password'],
  },
  {
    text: 'BP ID',
    field: 'bpImageId',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['bpImageId'],
  },
  {
    text: 'Shared',
    field: 'shared',
    isSort: true,
    type: FILTER_TYPE.SELECT,
    accessor: getSharedIsPreRegistrationsUser,
  },
  {
    text: 'Count',
    field: 'useCount',
    isSort: true,
    type: FILTER_TYPE.NONE,
    accessor: ['useCount'],
  },
  {
    text: 'Uploaded at',
    field: 'createdAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getCreatedAtWithTime,
  },
];

interface State {
  items: PreRegistrationsUser[];
  currentPage: number;
  selectedItems: PreRegistrationsUser[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  isUploadCSVFormModalOpen: boolean;
  isConfirmationModalOpen: boolean;
  isResetLoginCountModalOpen: boolean;
  isErrorModalOpen: boolean;
  errorMessage: string;
  isResponseTextModalOpen: boolean;
  responseText: string;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class PreRegistrationsUsers extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      isUploadCSVFormModalOpen: false,
      isConfirmationModalOpen: false,
      isResetLoginCountModalOpen: false,
      isErrorModalOpen: false,
      errorMessage: '',
      isResponseTextModalOpen: false,
      responseText: '',
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters(COLUMNS, search);

    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isFilterExist(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter(page, where, order);

    const getItemsPromise = getPreRegistrationsUsers(user, serverQueryFilter);
    const getItemsCountPromise = getPreRegistrationsUsersCount(user, where);

    const promises = [getItemsCountPromise, getItemsPromise];

    return Promise.all(promises).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false,
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&'),
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllPreRegistrationsUsers(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&'),
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&'),
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: '',
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: '',
    });
  };

  onCloseResponseTextModalClick = () => {
    this.setState({
      isResponseTextModalOpen: false,
      isUploadCSVFormModalOpen: false,
      responseText: '',
      isLoading: true,
    });
    this.setItems();
  };

  onShowStatusUploadPreReg = (isErrorStatus, responseText) => {
    this.setState({
      isLoading: true,
      isUploadCSVFormModalOpen: false,
    });
    if (isErrorStatus) {
      console.error(responseText);
      this.setState({
        isLoading: false,
        isErrorModalOpen: true,
        errorMessage: responseText,
      });
    } else {
      if (typeof responseText !== 'undefined') {
        this.setState({
          isLoading: false,
          isResponseTextModalOpen: true,
          responseText: responseText,
        });
      } else {
        this.setState({
          isLoading: false,
        });
      }
    }
  };

  renderFormModal(): React.ReactNode {
    const { isUploadCSVFormModalOpen } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal isOpen={isUploadCSVFormModalOpen}>
        <PreRegistrationsUsersLogsForm
          user={user}
          onCancel={this.onCancelButtonClick}
          onShowStatusUploadPreReg={this.onShowStatusUploadPreReg}
        />
      </SimpleModal>
    );
  }

  onCancelButtonClick = () => {
    this.setState({
      isLoading: true,
      isUploadCSVFormModalOpen: false,
    });
    this.setItems();
  };

  onCreateUploadCSVClick = () => {
    this.setState({
      isUploadCSVFormModalOpen: true,
    });
  };

  onDeletePreRegistrationsUserClick = () => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isLoading: true,
      isConfirmationModalOpen: false,
    });
    const selectedItemIds = selectedItems.map(selectedItem => selectedItem.id);

    deletePreRegistrationsUser(user, selectedItemIds).then(res => {
      this.setState({
        selectedItems: [],
        isSelectAllChecked: false,
      });

      this.setItems();
    });
  };

  onResetLoginCountClick = () => {
    const { user } = this.props;

    this.setState({
      isLoading: true,
      isResetLoginCountModalOpen: false,
    });

    resetLoginCountPreRegistrationsUser(user).then(res => {
      this.setState({
        selectedItems: [],
        isSelectAllChecked: false,
      });

      this.setItems();
    });
  };

  showConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: true,
    });
  };

  resetLoginCountModal = () => {
    this.setState({
      isResetLoginCountModalOpen: true,
    });
  };

  hideResetLoginCountModal = () => {
    this.setState({
      isResetLoginCountModalOpen: false,
    });
  };

  hideConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: false,
    });
  };

  renderConfirmationModal(): React.ReactNode {
    const { isConfirmationModalOpen, selectedItems } = this.state;

    return (
      <SimpleModal
        isOpen={isConfirmationModalOpen}
        title={'Confirmation'}
        body={`Are you sure you want to remove ${
          selectedItems.length === 1 ? 'Pre Registration' : 'Pre Registrations'
        }?`}
        buttonText={'Remove'}
        buttonCancelText={'Cancel'}
        onButtonClick={this.onDeletePreRegistrationsUserClick}
        onCloseClick={this.hideConfirmationModal}
      />
    );
  }

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  renderResponseTextAfterDownloading(): React.ReactNode {
    const { responseText, isResponseTextModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isResponseTextModalOpen}
        title={'Result'}
        body={responseText}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseResponseTextModalClick}
      />
    );
  }

  renderResetLoginCountModalOpen(): React.ReactNode {
    const { isResetLoginCountModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isResetLoginCountModalOpen}
        title={'Confirmation'}
        body={`Are you sure you want to reset login count to zero?`}
        buttonText={'Reset'}
        buttonCancelText={'Cancel'}
        onButtonClick={this.onResetLoginCountClick}
        onCloseClick={this.hideResetLoginCountModal}
      />
    );
  }

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      isUploadCSVFormModalOpen,
      isConfirmationModalOpen,
      isResetLoginCountModalOpen,
      isErrorModalOpen,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isUploadCSVFormModalOpen || isConfirmationModalOpen || isResetLoginCountModalOpen || isErrorModalOpen
        ? 'mt-3 modal-open'
        : 'mt-3';

    const actionItems = [
      {
        itemText: 'Upload a new Pre Registration',
        onItemClick: this.onCreateUploadCSVClick,
        isActive: selectedItems.length === 0,
      },
      {
        itemText: selectedItems.length === 1 ? 'Delete Pre Registration' : 'Delete Pre Registrations',
        onItemClick: this.showConfirmationModal,
        isActive: selectedItems.length > 0,
      },
      {
        itemText: 'Reset login count to zero',
        onItemClick: this.resetLoginCountModal,
        isActive: true,
      },
    ];

    const filterOptions = {
      shared: getSelectOptionForYesOrNo(),
    };

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderResetLoginCountModalOpen()}
        {this.renderFormModal()}
        {this.renderResponseTextAfterDownloading()}
        {this.renderSendingError()}
        {this.renderConfirmationModal()}
        <div className="row">
          <div className="col-md-12">
            <Grid
              dataItems={items}
              filters={filters}
              currentPage={currentPage}
              total={total}
              isSelectAllChecked={isSelectAllChecked}
              isDataFiltered={isDataFiltered}
              sortDirection={sortDirection}
              sortColumnsName={sortColumnsName}
              isShowFilter={isShowFilter}
              dataItemsSelected={selectedItems}
              columns={COLUMNS}
              actionItems={actionItems}
              options={filterOptions}
              onItemClick={this.onItemClick}
              onSortClick={this.onTableSortClick}
              onApplyFilterClick={this.onApplyFilterClick}
              onClearFilterClick={this.onClearFilterClick}
              onTableFilterChange={this.onTableFilterChange}
              onTableFilterClick={this.onTableFilterClick}
              setCurrentPageParams={this.setCurrentPageParams}
              onSelectAllClick={this.onSelectAllClick}
              onSelectAllOnPageClick={this.onSelectAllOnPageClick}
              onUnselectAllClick={this.onUnselectAllClick}
            />
          </div>
        </div>
      </div>
    );
  }
}
